"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Add_1 = require("@mui/icons-material/Add");
const AddButtonV2_styles_1 = require("./AddButtonV2.styles");
const AddButtonV2 = ({ onClick, disabled = false, elevated = true, quantity = 0 }) => {
    const classes = (0, AddButtonV2_styles_1.useAddButtonV2Styles)({ elevated });
    return ((0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: classes.root, onClick: onClick, disabled: disabled, "aria-label": "add", children: quantity > 0 ? (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: classes.quantity, children: quantity }) : (0, jsx_runtime_1.jsx)(Add_1.default, { sx: classes.icon }) }));
};
exports.default = AddButtonV2;
